import React, { useEffect } from "react";

import { Language, TRANSLATION_LANGUAGES } from "~types/types";
import { capitalize } from "~utils/stringUtil";
import { Tracker } from "~utils/tracker";

import styles from "./style.module.css";

const LANGUAGE_NAMES: Record<Language, string> = {
    en: "English",
    ja: "Japanese",
    de: "German",
    es: "Spanish",
    pt: "Portuguese",
};

const HUMAN_FRIENDLY_LANGUAGE_NAME = {
    [TRANSLATION_LANGUAGES.EN]: "English",
    [TRANSLATION_LANGUAGES.JA]: "Japanese",
    [TRANSLATION_LANGUAGES.FR]: "French",
    [TRANSLATION_LANGUAGES.DE]: "German",
    [TRANSLATION_LANGUAGES.ES]: "Spanish",
    [TRANSLATION_LANGUAGES.PT]: "Portuguese",
    [TRANSLATION_LANGUAGES.IT]: "Italian",
    [TRANSLATION_LANGUAGES.ZT]: "Traditional Chinese",
    [TRANSLATION_LANGUAGES.KO]: "Korean",
    [TRANSLATION_LANGUAGES.ZH]: "Simplified Chinese",
};

interface TranslationDisclaimerProps {
    position: "top" | "bottom";
    sourceLanguage: Language;
    targetLanguage: TRANSLATION_LANGUAGES;
}

const translationTracker = new Tracker({
    event: "translation_event",
    category: "engagement",
});

const TranslationNotice: React.FC<
    Omit<TranslationDisclaimerProps, "position">
> = ({ sourceLanguage, targetLanguage }) => {
    useEffect(() => {
        translationTracker.trackEvent({
            action: "impression",
            label: `article_in_${targetLanguage}`,
        });
    }, []);

    return (
        <div className={styles.translationDisclaimer}>
            This article has been translated from{" "}
            {capitalize(LANGUAGE_NAMES[sourceLanguage])} to{" "}
            {HUMAN_FRIENDLY_LANGUAGE_NAME[targetLanguage]}.
        </div>
    );
};

const TranslationDisclaimer: React.FC<TranslationDisclaimerProps> = ({
    position,
    sourceLanguage,
    targetLanguage,
}) => {
    if (position === "top") {
        return (
            <TranslationNotice
                sourceLanguage={sourceLanguage}
                targetLanguage={targetLanguage}
            />
        );
    }

    return (
        <div className={styles.translationDisclaimer}>
            This service may contain translation powered by Google. Google
            disclaims all warranties related to the translations, express or
            implied, including any warranties of accuracy, reliability, and any
            implied warranties of merchantability, fitness for a particular
            purpose and noninfringement.
        </div>
    );
};

export default TranslationDisclaimer;
